// Locale-aware drop-in replacement for react-router-dom.
// Re-exports everything, but overrides Link/NavLink/useNavigate so that
// internal absolute paths are automatically prefixed with the active locale.
import React from "react";
import {
  Link as RLink,
  NavLink as RNavLink,
  useNavigate as useRNavigate,
} from "react-router-dom";
import { currentLocale, localizePath } from "@/i18n/locale";

export * from "react-router-dom";

export const Link = React.forwardRef(function LocalizedLink({ to, ...props }, ref) {
  return <RLink ref={ref} to={localizePath(to, currentLocale())} {...props} />;
});

export const NavLink = React.forwardRef(function LocalizedNavLink({ to, ...props }, ref) {
  return <RNavLink ref={ref} to={localizePath(to, currentLocale())} {...props} />;
});

export function useNavigate() {
  const navigate = useRNavigate();
  return React.useCallback(
    (to, opts) => navigate(typeof to === "number" ? to : localizePath(to, currentLocale()), opts),
    [navigate],
  );
}

// Raw (non-localized) navigate for the language switcher and admin.
export const useRawNavigate = useRNavigate;
